import { ICheckableObject } from "../../../../../../domain/editableFormat/objects";
import { ICheckableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import {
  PrintBehaviorTranslator,
  QuoteBehaviorTranslator,
  EditBehaviorTranslator,
  TooltipBehaviorTranslator,
  NaturalTextBehaviorTranslator,
  CategoryNameTranslator,
  RelationReplacer,
  TranscribeBehaviorTranslator,
  EmptyAlertAllowBehaviorTranslator,
  GroupAlertAllowBehaviorTranslator,
  ScriptExecuteTriggerBehaviorTranslator,
} from "../properties";
import { RectangleCoordinatableObjectTranslator } from "./RectangleCoordinatableObjectTranslator";

export class CheckableObjectTranslator<TObject extends ICheckableObject, TBean extends ICheckableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new RectangleCoordinatableObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
    source.printBehavior = this.printBehavior.from(bean);
    source.quoteBehavior = this.quoteBehavior.from(bean);
    source.editBehavior = this.editBehavior.from(bean);
    source.tooltipBehavior = this.tooltipBehavior.from(bean);
    source.naturalTextBehavior = this.naturalTextBehavior.from(bean);
    source.transcribeBehavior = this.transcribeBehavior.from(bean);
    source.emptyAlertAllowBehavior = this.emptyAlertAllowBehavior.from(bean);
    source.groupAlertAllowBehavior = this.groupAlertAllowBehavior.from(bean);
    source.scriptExecuteTriggerBehavior = this.scriptExecuteTriggerBehavior.from(bean);
    source.categoryName = this.categoryName.from(bean);
    // check/circleselectはHISマスタと突き合わせるまでHIS項目かどうか分からないのでTranslatorではhisName一本で扱う.
    source.name = "";
    source.informationKey = bean["@name"];
    // checkBehaviorはbeanの対応する属性が派生クラスで違うので派生クラスで実装する.
  }

  overwriteBean(source: TBean, object: TObject): void {
    source["@hide"] = this.printBehavior.to(object).hide;
    source["@quote"] = this.quoteBehavior.to(object).quote;
    source["@vanish"] = this.editBehavior.to(object).vanish;
    source["@tooltip"] = this.tooltipBehavior.to(object).tooltip;
    source["@natural-view"] = this.naturalTextBehavior.to(object).naturalView;
    source["@natural-text"] = this.naturalTextBehavior.to(object).naturalText;
    this.relationReplacer.replaceBeans(source, "text-paste", this.transcribeBehavior.to(object.transcribeBehavior));
    this.relationReplacer.replaceBeans(
      source,
      "parent-alert",
      this.emptyAlertAllowBehavior.to(object.emptyAlertAllowBehavior),
      this.groupAlertAllowBehavior.to(object.groupAlertAllowBehavior));
    this.relationReplacer.replaceBeans(source, "script-link-output", this.scriptExecuteTriggerBehavior.to(object.scriptExecuteTriggerBehavior));
    source["@item-name"] = this.categoryName.to(object);
    // check/circleselectはHISマスタと突き合わせるまでHIS項目かどうか分からないのでTranslatorではhisName一本で扱う.
    source["@name"] = object.informationKey;
    // checkBehaviorはbeanの対応する属性が派生クラスで違うので派生クラスで実装する.
  }

  private readonly printBehavior = new PrintBehaviorTranslator();
  private readonly quoteBehavior = new QuoteBehaviorTranslator();
  private readonly editBehavior = new EditBehaviorTranslator();
  private readonly tooltipBehavior = new TooltipBehaviorTranslator();
  private readonly naturalTextBehavior = new NaturalTextBehaviorTranslator();
  private readonly categoryName = new CategoryNameTranslator();
  private readonly transcribeBehavior = new TranscribeBehaviorTranslator();
  private readonly emptyAlertAllowBehavior = new EmptyAlertAllowBehaviorTranslator();
  private readonly groupAlertAllowBehavior = new GroupAlertAllowBehaviorTranslator();
  private readonly scriptExecuteTriggerBehavior = new ScriptExecuteTriggerBehaviorTranslator();
  private readonly relationReplacer = new RelationReplacer();
}
